import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';

export enum ModelMenuRefreshEventsKeys {
    REFRESH_MENU_VALUES_VALUES = 'mergeMenuValuesCacheRefresh',
    REFRESH_MENU_ITEM_VALUES = 'refreshItemValues',
    REFRESH_GROUP_ITEM_VALUES = 'refreshGroupItemValues',
}

export interface ModelMenuRefreshEventsMap {
    [ModelMenuRefreshEventsKeys.REFRESH_MENU_VALUES_VALUES]: IBaseModel;
    [ModelMenuRefreshEventsKeys.REFRESH_MENU_ITEM_VALUES]: void;
    [ModelMenuRefreshEventsKeys.REFRESH_GROUP_ITEM_VALUES]: void;
}
